import { Tag } from 'antd';
import { Link } from 'react-router-dom';

export const WIDGET_TYPE_OPTIONS = [
  { value: 'portfolio', label: 'Portfolio' },
  { value: 'onboard_checklist', label: 'Onboard Checklist' },
  { value: 'warning_message', label: 'Warning Message' },
  { value: 'buy_pending_orders', label: 'Buy Pending Orders' },
  { value: 'menu', label: 'Menu' },
  { value: 'callout_card', label: 'Callout Card' },
  { value: 'banners', label: 'Banners' },
  { value: 'faq', label: 'FAQ' },
];

export const columnsGenerator = params => [
  {
    title: '',
    dataIndex: 'id',
    align: 'center',
    render: id => <Link to={`/admin/home-widgets/${id}`}>View</Link>,
  },
  {
    title: 'Ordering',
    dataIndex: 'ordering',
    align: 'center',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    render: value => <Tag color="blue">{value}</Tag>,
  },
  {
    title: 'Title',
    dataIndex: 'title',
  },
  {
    title: 'Description',
    dataIndex: 'description',
  },
  {
    title: 'Active',
    dataIndex: 'is_active',
    align: 'center',
    render: value =>
      value ? <Tag color="green">Active</Tag> : <Tag color="default">Inactive</Tag>,
  },
];
